import type { ComponentProps } from 'react'
import { cn } from '@/lib/utils'

/* Identifier — a room number, task reference, reservation reference, barcode.

   Two rules, both easy to get wrong in an Arabic build:
     1. Western digits, always. Room 412 is painted 412 on the door and called
        "four twelve" by the supervisor, in both languages. Rendering ٤١٢ on the
        handset while the door says 412 is an operational error.
     2. Isolated left-to-right run, so Arabic bidirectional reordering cannot
        reverse or re-sequence it inside a sentence. `unicode-bidi: isolate` is
        what does this; direction:ltr alone is not enough.

   Quantities are the opposite case and DO localise — use formatCount(). */

export function Identifier({ className, children, ...props }: ComponentProps<'span'>) {
  return (
    <span className={cn('hk-ltr-run font-mono font-semibold text-primary', className)} {...props}>
      {children}
    </span>
  )
}
